import { memo, ReactNode } from 'react';
import { Box, Text } from '@chakra-ui/react';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../constants';

export interface BuilderModeToolbarTabProperties {
  label: string;
  icon: ReactNode;
  isActive: boolean;
  onClick: () => void;
}

const BuilderModeToolbarTab = memo(
  ({ label, icon, isActive, onClick }: BuilderModeToolbarTabProperties) => (
    <Box
      as='button'
      type='button'
      onClick={onClick}
      aria-current={isActive ? 'page' : undefined}
      display='inline-flex'
      alignItems='center'
      justifyContent='center'
      gap='8px'
      h='100%'
      minH={BUILDER_MODE_V1_LAYOUT.subToolbarMinHeight}
      px={BUILDER_MODE_V1_LAYOUT.subToolbarTabPaddingX}
      py={BUILDER_MODE_V1_LAYOUT.subToolbarTabPaddingY}
      bg={isActive ? BUILDER_MODE_V1_TOKENS.activeBg : 'transparent'}
      borderBottom='2px solid'
      borderColor={isActive ? BUILDER_MODE_V1_TOKENS.primary : 'transparent'}
      // borderRadius={
      //   isActive
      //     ? `${BUILDER_MODE_V1_LAYOUT.subToolbarTabRadius} ${BUILDER_MODE_V1_LAYOUT.subToolbarTabRadius} 0 0`
      //     : 0
      // }
      cursor='pointer'
      flexShrink={0}
      _hover={{ bg: BUILDER_MODE_V1_TOKENS.activeBg }}
    >
      {icon}
      <Text
        fontSize={BUILDER_MODE_V1_LAYOUT.subToolbarTabFontSize}
        fontWeight='500'
        color={BUILDER_MODE_V1_TOKENS.textDark}
        lineHeight='normal'
        whiteSpace='nowrap'
      >
        {label}
      </Text>
    </Box>
  ),
);

BuilderModeToolbarTab.displayName = 'BuilderModeToolbarTab';

export default BuilderModeToolbarTab;
